import { AgTechQuery, useAgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { SaleDiscount } from "./SaleDiscountData";
import { AgTechIndex, Index } from "@agtech/core/utilities/AgTechUtilities";
import AgTechQueryLoadingSurface from "@agtech/core/data/queries/AgTechQueryLoadingSurface";

export const SaleDiscountQueryKey = 'SaleDiscounts';

export const DiscountDataGetAllDiscountsQuery: AgTechQuery<any, AgTechIndex<SaleDiscount>> = {
    queryKey: () => [SaleDiscountQueryKey],
    query: async (props) => {
        return await props.http.getEntity<SaleDiscount[], AgTechIndex<SaleDiscount>>({
            request: 'Discounts',
            convert: discounts => Index(discounts, discount => discount.id)
        });
    },
    content: {
        loadingText: 'Loading sale discounts...',
        failureText: 'Failed to load sale discounts.'
    }
}

/// Providers

export const SaleDiscountDataProvider = (props: {
    children: (discounts: AgTechIndex<SaleDiscount>) => JSX.Element
}) => {
    const getDiscountsQuery = useAgTechQuery({
        query: DiscountDataGetAllDiscountsQuery
    });

    return (
        <AgTechQueryLoadingSurface
            query={getDiscountsQuery}
            children={props.children}
        />
    )
}